<template>
  <span>
    <div
      id="message-register"
      :class="{'boss-layout-block-large':isEnabledForCreateMessageAccordion}"
    >
      <template v-if="isWithdraw">
        <span
          class="boss-annotation-text font-size-1-1em text-center"
          data-test="withdraw"
        >
          <div>
            応募後に退会したため、メッセージ送信ができません。
          </div>
          <div>
            レジュメ内のご連絡先に、直接ご連絡ください。
          </div>
        </span>
      </template>
      <template v-else>
        <accordion
          v-if="canSendMessage"
          ref="register"
          :is-open="false"
          :disabled="!isEnabledForCreateMessageAccordion"
        >
          <template #head>メッセージ作成</template>
          <template #body>
            <applicant-message-register
              :entry-ids="entryIds"
              :message-to-applicant.sync="messageToApplicant"
              @registered="registered"
            />
          </template>
        </accordion>
        <div
          v-if="!isEnabledForCreateMessageAccordion"
          class="boss-annotation-text pega-entry-message-reservation-reserved-label"
          data-test="reserved"
        >
          ※メッセージ予約中
        </div>
      </template>
    </div>
    <div class="boss-layout-block-large">
      <accordion :is-open="true">
        <template #head>メッセージ履歴</template>
        <template #body>
          <applicant-message-history
            ref="applicantMessageHistory"
            :entry-id="entryId"
            :is-withdraw="isWithdraw"
            @setMessage="setMessage"
            @setIsMessageReserved="setIsMessageReserved"
          />
        </template>
      </accordion>
    </div>
  </span>
</template>

<script>
import ApplicantMessageRegister from '@/components/organisms/ApplicantMessageRegister'
import Accordion from '@/components/atoms/Accordion'
import ApplicantMessageHistory from '@/components/organisms/ApplicantMessageHistory'
import { mapGetters } from 'vuex'
import SelectionEventBus from '@/lib/selectionEventBus'

export default {
  components: {
    Accordion,
    ApplicantMessageRegister,
    ApplicantMessageHistory
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      messageToApplicant: null,
      isMessageReserved: false,
      isTriggeredEnableCreateMessage: false
    }
  },
  computed: {
    ...mapGetters([
      'canSendMessage'
    ]),
    isEnabledForCreateMessageAccordion () {
      return !this.isMessageReserved || this.isTriggeredEnableCreateMessage
    },
    entryIds () {
      return [this.entryId]
    }
  },
  methods: {
    setMessage (data) {
      this.$set(this, 'messageToApplicant', null)
      this.$set(this, 'isTriggeredEnableCreateMessage', true)

      this.$nextTick(() => {
        this.$set(this, 'messageToApplicant', data)
        this.$refs.register.status.isOpen = true
        this.$scrollTo('#message-register', 0, { offset: -35 })
      })
    },
    setIsMessageReserved (isMessageReserved) {
      this.$set(this, 'isMessageReserved', isMessageReserved)
    },
    registered () {
      this.$refs.register.toggle()
      this.$set(this, 'isTriggeredEnableCreateMessage', false)
      this.$refs.applicantMessageHistory.fetchAllMessage()
      SelectionEventBus.emitSelectionUpdate()
    }
  }
}
</script>
